import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistStore,
} from "redux-persist";
// import rootReducers from "./rootReducers";
import basketReducer from "./authReducers";
import authorizationReducer from "./authorizationReducers";
import likeReducer from "./likeReducers";

const isDev = process.env.NODE_ENV === "development";

// const persistConfig = {
//   key: "root",

//   version: 12,
//   storage,
//   whitelist: [],
// };

// const rootReducer = combineReducers(rootReducers);

// const authReducer = combineReducers(authReducers);
// const persistedReducer = persistReducer(persistConfig, rootReducer);
const middlewareLogger: any = !!isDev ? logger : [];

export const store = configureStore({
  reducer: {
    basketReducer,
    authorizationReducer,
    likeReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(middlewareLogger),
});

export let persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
